import React from 'react';

const Loading = () => {
    return (
        <div className='h-screen flex justify-center'>
            <button class="btn loading">loading</button>
        </div>
    );
};

export default Loading;